import { useReferralCapture } from '@/services/referral-storage';
import { Navigate, NavigateProps } from '@/util/react-router-dom';

export function PreprocessRootRedirect(props: NavigateProps) {
  useReferralCapture();

  return <Navigate {...props} />;
}
